/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */
import React, { PureComponent } from "react";
import {
  formatDateProfileMonth,
  formatDateArabicDDMYYYY,
  dayDifference,
  hourDifference,
  formatDayHour,
  formatTimeHourMinute
} from "../../pages/helper";
import { arabicContent } from "../../constants/index";
import uiConfig from "../../uiConfig";
import config from "../../service/config";
//import uiConfigMaya from "../../uiConfigMaya"

export default class RedeemOfferCard extends PureComponent {
  state = {};

  renderDateField = (date) => {
    let formattedDate;
    if (hourDifference(date) < 24) {
      formattedDate = `Offer valid for ${formatTimeHourMinute(date)}`;
    } else if (dayDifference(date) < 2) {
      formattedDate = `Offer valid for ${formatDayHour(date)}`;
    } else if (dayDifference(date) <= 30) {
      formattedDate = `Offer valid for next ${dayDifference(date)} days`;
    } else if (dayDifference(date) > 30) {
      formattedDate = `Offer valid until ${formatDateProfileMonth(date)}`;
    }

    return formattedDate;
  };

  /* Render Functions */

  
  render() {
    const lang = localStorage.getItem("language");
    const { item, claimStatus, itemUrl } = this.props;
    return (item?.isExpired ?
      <div
        className="card redeem-offer-card"
        style={{
          background: "#E30613",
          cursor: "unset"
        }}
      >
        <div
          className="oops-text"
        >
          Oops!
        </div>
        <div
          className="expire-text"
        >
          This offer has expired. Do check out other exciting offers!
        </div>
        <div
          style={{
            color: "#FFFFFF"
          }}
          className="valid-text text-center"
        >
          Offer expired on
          <b
            className="pl-6"
            style={{
              color: "#FFFFFF"
            }}
          >
            {formatDateProfileMonth(item.validTo)}
          </b>
        </div>
      </div>
      :
      <div
        className="card redeem-offer-card"
        style={{
          background:
            uiConfig.config.whitelabel.merchant_details.redeem_card.bgColor
        }}
        onClick={() => this.props._onClick(item.id)}
      >
        {claimStatus ? (
          <h3
            style={{
              color:
                uiConfig.config.whitelabel.merchant_details.redeem_card.headText
            }}
          >
            {lang === "AR" ? arabicContent.redeemOffer : `To Know More`}
          </h3>
        ) : (
          <h3
            style={{
              color:
                uiConfig.config.whitelabel.merchant_details.redeem_card.headText
            }}
          >
            {lang === "AR" ? arabicContent.availOffer : `To Know More`}
          </h3>
        )}
        {claimStatus ? (
          <div
            className="redeem-code"
            style={
              uiConfig.config.whitelabel.merchant_details.redeem_card.redeem_now
            }
          >
            {lang === "AR" ? arabicContent.claimed : "Click here"}
          </div>
        ) : (
          <div
            className="avail-code"
            style={
              uiConfig.config.whitelabel.merchant_details.redeem_card.redeem_now
            }
          >
            {lang === "AR" ? arabicContent.redeemNow : `Click here`}
          </div>
        )}
        {
          claimStatus ? (
            item.redemptionCode ? (
              <div
                className="offer-text"
                style={
                  uiConfig.config.whitelabel.merchant_details.redeem_card
                    .offerText
                }
              >
                {item?.isOnline ? 
                <>
                {lang === "AR" ? arabicContent.redeemText5 : "To redeem this offer, visit "} <span className="ellipsis">{itemUrl} </span>
                </> 
                : <></>}
                {" "}
              </div>
            ) : item.cashbackValue ? (
              <div
                className="offer-text"
                style={{
                  borderBottom: `1px solid ${uiConfig.config.whitelabel.merchant_details.redeem_card.offerText.borderColor}`,
                  color:
                    uiConfig.config.whitelabel.merchant_details.redeem_card
                      .offerText.color
                }}
              >
                {lang === "AR"
                  ? arabicContent.redeemText2
                  : `Your cashback offer for up to `}
                {item.cashbackValue + item?.currency}
                {lang === "AR"
                  ? arabicContent.redeemText3
                  : ` cashback has been successfully applied!`}
                <br />
                {lang === "AR"
                  ? arabicContent.redeemText4
                  : `To avail the cashback offer, please use the ${config.clientName} card at the time of checkout`}
              </div>
            ) : (
              <div
                className="offer-text"
                style={
                  uiConfig.config.whitelabel.merchant_details.redeem_card
                    .offerText
                }
              >
                {item?.isOnline ? 
                <>
                {lang === "AR" ? arabicContent.redeemText5 : "To redeem this offer, visit "} <span className="ellipsis">{itemUrl} </span>
                </> 
                : <></>}{" "}
              </div>
            )
          ) : (
            <div
              className="offer-text"
              style={
                uiConfig.config.whitelabel.merchant_details.redeem_card
                  .offerText
              }
            >
              {/* {lang === "AR"
                ? arabicContent.redeemText1
                : 
                item.claimedCount +
                " + Claimed & Over " +
                item.redeemedCount +
                " unlocked today. To redeem this offer, visit "} */}
              {item?.isOnline ? (<> <span className="ellipsis">{itemUrl} </span></> ) : <></>}
            </div>
          )

          //  item.redemptionCode ?
          //  <div className="offer-text" style={uiConfig.config.whitelabel.merchant_details.redeem_card.offerText}>

          //  {lang === 'AR' ? arabicContent.redeemText1 : `To redeem this offer, visit `}<span className="ellipsis">{itemUrl} </span> </div>
          //  :
          //  claimStatus && item.cashbackValue ?
          //  <div className="offer-text" style={{borderBottom:`1px solid ${uiConfig.config.whitelabel.merchant_details.redeem_card.offerText.borderColor}`,color:uiConfig.config.whitelabel.merchant_details.redeem_card.offerText.color }}>{lang === 'AR' ? arabicContent.redeemText2 : `Your cashback offer for up to `}{item.cashbackValue+"%"}{lang === 'AR' ? arabicContent.redeemText3 : ` cashback has been successfully applied!`}<br/>{lang === 'AR' ? arabicContent.redeemText4 : `To avail the cashback offer, please use the ${config.clientName} at the time of checkout`}</div>
          //  :
          //  <div className="offer-text" style={uiConfig.config.whitelabel.merchant_details.redeem_card.offerText}>{lang === 'AR' ? arabicContent.redeemText5 : `To redeem this offer, visit `}<span className="ellipsis">{itemUrl} </span> </div>

          //   item.redemptionCode ?
          //   <div className="offer-text" style={uiConfig.config.whitelabel.merchant_details.redeem_card.offerText}>
          //   {lang === 'AR' ? arabicContent.redeemText1 : item.claimedCount+" + Claimed & Over "+item.redeemedCount+" unlocked today. To redeem this offer, visit "}<span className="ellipsis">{itemUrl} </span> </div>
          //   :
          //   claimStatus ?
          //   <div className="offer-text" style={{borderBottom:`1px solid ${uiConfig.config.whitelabel.merchant_details.redeem_card.offerText.borderColor}`,color:uiConfig.config.whitelabel.merchant_details.redeem_card.offerText.color }}>{lang === 'AR' ? arabicContent.redeemText2 : `Your cashback offer for up to `}{item.cashbackValue}{lang === 'AR' ? arabicContent.redeemText3 : ` cashback has been successfully applied!`}<br/>{lang === 'AR' ? arabicContent.redeemText4 : `To avail the cashback offer, please use the ${config.clientName} card in the POS`}</div>
          //   :
          //   <div className="offer-text" style={uiConfig.config.whitelabel.merchant_details.redeem_card.offerText}>{lang === 'AR' ? "مقفلة اليوم. لتخليص هذا العرض في  "+item.redeemedCount+" مطالب بها وأكثر من +"+item.claimedCount : item.claimedCount+" + Claimed & Over "+item.redeemedCount+" unlocked today. To redeem this offer, visit "}<span className="ellipsis">{itemUrl} </span> </div>
        }
        {/* {item.url&&<div className="offer-text"> 25,000 + Claimed & Over 900 unlocked today. To redeem this offer at {itemUrl} </div>} */}
        <div
          style={{
            color:
              uiConfig.config.whitelabel.merchant_details.redeem_card.offerText
                .color
          }}
          className={`valid-text ${lang === "AR" ? "flex flex-row-reverse justify-end" : ""
            }`}
        >
          {lang === "AR" ? arabicContent.redeemText6 : ``}
          {/* <b
            className={`${lang === "AR" ? "pl-6" : ""}`}
            style={{
              color:
                uiConfig?.config?.whitelabel?.merchant_details?.redeem_card
                  ?.offerText?.validDate
            }}
          >
            {lang === "AR"
              ? formatDateArabicDDMYYYY(item.validTo)
              : this.renderDateField(item.validTo).toUpperCase()}
          </b> */}
        </div>
      </div>
    );
  }
}